import * as React from "react";
const SvgFiRrAssessment = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-assessment_svg__a)">
      <path
        fill="#062147"
        d="M11 23a1 1 0 0 1-1 1H5c-2.757 0-5-2.243-5-5V5.001A5.006 5.006 0 0 1 4.999 0H15c2.757 0 5 2.242 5 4.999v2a1 1 0 1 1-2 0v-2c0-1.654-1.346-3-3-3H4.999c-1.654 0-3 1.347-3 3.001v13.999c0 1.654 1.346 3 3 3h5a1 1 0 0 1 1 1zm12.553.553a.997.997 0 0 1-1.414 0l-2.666-2.666A5.97 5.97 0 0 1 16 22a6 6 0 1 1 6-6 5.97 5.97 0 0 1-1.113 3.473l2.666 2.666a1 1 0 0 1 0 1.414m-6.573-5.227 2.703-2.614a1 1 0 1 0-1.385-1.443l-2.713 2.624a.37.37 0 0 1-.522 0l-1.132-1.108a1 1 0 0 0-1.399 1.43l1.132 1.108a2.37 2.37 0 0 0 1.664.674c.602 0 1.201-.225 1.653-.671zM7 5H5a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2m0 10H5a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2m4-10a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2zm-4 5H5a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-assessment_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAssessment;
